import HeaderAndFooterPresentationMetadata from './PresentationMetadataHeaderAndFooter';

export default [() => {
    return HeaderAndFooterPresentationMetadata;
}];